import { connect } from "react-redux";

import { State } from "rivals/redux/reducer";
import { getBillingHistoryTransactions } from "rivals/redux/user/selectors";
import { BillingHistory as StateProps } from "./types";
import BillingHistory from ".";

const mapStateToProps = (state: State): StateProps => ({
  transactions: getBillingHistoryTransactions(state)
});

export default connect(mapStateToProps)(BillingHistory);
